import $ from 'jquery';

$(document).on('click', '.form-quantity .js-plus, .form-quantity .js-minus', function () {
	var $qty = $(this).closest('.form-quantity').find('.form__input-qty');
	var currentVal = parseInt($qty.val());
	var max = parseInt($qty.attr('max'));
	var min = parseInt($qty.attr('min'));
	var step = $qty.attr('step') ? parseInt($qty.attr('step')) : 1;

	if ($(this).hasClass('js-plus')) {
		if ( ! currentVal ) {
			$qty.val( step );
		} else {
			if (max && (max === currentVal || currentVal > max)) {
				$qty.val(max);
			} else {
				$qty.val(currentVal + step);
			}
		}
	} else {
		if ( ! currentVal ) {
			$qty.val( 0 );
		} else {
			if (min && (min === currentVal || currentVal < min)) {
				$qty.val(min);
			} else {
				$qty.val(currentVal - step);
			}
		}
	}

	$qty.trigger('change');
});
